import { Button, Image, Link, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { getAsset } from '@pelicargo/tenants';
import { HiChevronDown, HiOutlineChatAlt2, HiOutlineMail } from 'react-icons/hi';

import { trpc } from '../config/trpc';
import { useFrontChat } from '../hooks/front/useFrontChat';
import { EmailRequestProps } from '../hooks/useEmailRequest';

export const SupportButton = ({ requestId, type }: EmailRequestProps) => {
  const { handleChatSupport } = useFrontChat({ requestId });
  const { data: prefilledSupportEmailLink } = trpc.getPrefilledSupportEmail.useQuery(
    { requestId },
    { enabled: !!requestId, refetchOnWindowFocus: false },
  );

  return (
    <Menu>
      <MenuButton
        variant={type === 'Update' ? 'ghost' : undefined}
        leftIcon={<Image src={getAsset('support-icon.svg')} />}
        rightIcon={<HiChevronDown />}
        as={Button}
      >
        Support
      </MenuButton>
      <MenuList>
        <MenuItem as={Link} href={prefilledSupportEmailLink} icon={<HiOutlineMail />} isExternal>
          Help with Request
        </MenuItem>
        <MenuItem icon={<HiOutlineChatAlt2 />} onClick={handleChatSupport}>
          Chat
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
